(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kira-commission-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-kc-section]').forEach(section => {
      if (section.dataset.kcReady) return;
      section.dataset.kcReady = 'true';

      if (section.querySelector('[data-kc-forms]')) {
        const formStyles = "*{box-sizing:border-box}\ninput,textarea,select,button{box-sizing:border-box!important}\ninput[aria-invalid=\"true\"],textarea[aria-invalid=\"true\"]{border-color:#e02229!important}\n[data-current-step=\"form\"] section:has(>h2){display:none}\nform[data-testid=\"form\"]{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px!important;margin:0!important;text-align:left}\nform[data-testid=\"form\"]>div{min-width:0}\nform>div:has(shop-lead-capture),form>div:has(input[type=\"file\"]),form>div:has(textarea),form>button[type=\"submit\"]{grid-column:1/-1}\nform>div:has(>input),form>div:has(>textarea){display:flex!important;flex-direction:column-reverse!important;gap:0!important}\nform label:not(:has(input[type=\"file\"])){position:static!important;transform:none!important;display:block!important;width:auto!important;max-width:none!important;font:600 12px/1.5 Poppins,sans-serif!important;color:#3b2b24!important;margin:0 0 7px!important;padding:0!important;overflow:visible!important;white-space:normal!important}\nform input:not([type=\"file\"]),form textarea,form>div>button[aria-expanded]{width:100%!important;min-height:48px!important;background:#fff!important;border:1px solid #d9d0c6!important;box-shadow:none!important;border-radius:8px!important;padding:12px 14px!important;font:400 14px/1.6 Poppins,sans-serif!important;color:#3b2b24!important;text-align:left!important}\nform input:focus-visible,form textarea:focus-visible,form>div>button:focus-visible{outline:2px solid #b85626!important;outline-offset:2px!important}\nform textarea{min-height:120px!important;resize:vertical!important}\nform>div>p,[data-testid=\"date-birthday\"]>div:first-child{font:600 12px/1.5 Poppins,sans-serif!important;color:#3b2b24!important;margin:0 0 7px!important}\n[data-testid=\"date-birthday\"] input{min-width:0}\nform>button[type=\"submit\"]{justify-self:start!important;width:auto!important;min-height:48px!important;border-radius:40px!important;padding:12px 24px!important;background:#b85626!important;color:#fff!important;font:600 13px/1.5 Poppins,sans-serif!important;border:1px solid #b85626!important;box-shadow:none!important;margin:4px 0 0!important}\nform>button[type=\"submit\"]:hover{background:#87401f!important}\nform>button[type=\"submit\"]:disabled,form>button[type=\"submit\"][aria-disabled=\"true\"]{opacity:.6}\nform~div p{font:400 12px/1.65 Poppins,sans-serif!important;color:#786b64!important;text-align:left!important}\n@media(max-width:768px){form[data-testid=\"form\"]{grid-template-columns:1fr;gap:16px!important}form input:not([type=\"file\"]),form textarea{font-size:16px!important}form>button[type=\"submit\"]{justify-self:stretch!important;width:100%!important}}";
        let attempts = 0;
        const enhanceForm = () => {
          const host = section.querySelector('shopify-forms-embed');
          const shadow = host && host.shadowRoot;
          if (!shadow) return false;
          const applyStyles = () => {
            if (shadow.getElementById('kira-commission-form-styles')) return;
            const style = document.createElement('style');
            style.id = 'kira-commission-form-styles';
            style.textContent = formStyles;
            shadow.append(style);
          };
          applyStyles();
          const observer = new MutationObserver(() => {
            if (!section.isConnected) observer.disconnect(); else applyStyles();
          });
          observer.observe(shadow, {childList: true});
          return true;
        };
        if (!enhanceForm()) {
          const timer = setInterval(() => {
            attempts += 1;
            if (!section.isConnected || enhanceForm() || attempts >= 80) clearInterval(timer);
          }, 250);
        }
      }
      const read = section.querySelector('[data-kc-read]');
      if (read) read.addEventListener('click', () => { const open = read.getAttribute('aria-expanded') !== 'true'; read.setAttribute('aria-expanded', String(open)); section.querySelector('[data-kc-story]').classList.toggle('is-open', open); read.textContent = open ? 'Read Less' : 'Read More'; });
      const compare = section.querySelector('[data-kc-compare]');
      if (compare) {
        const tabs = Array.from(compare.querySelectorAll('[data-kc-tab]'));
        const select = index => {
          tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
          compare.querySelectorAll('[data-kc-panel]').forEach((panel, i) => panel.hidden = i !== index);
          compare.querySelectorAll('[data-kc-thumb]').forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        };
        tabs.forEach((tab, i) => { tab.addEventListener('click', () => select(i)); tab.addEventListener('keydown', event => { let n; if (event.key === 'ArrowRight') n = (i + 1) % tabs.length; if (event.key === 'ArrowLeft') n = (i + tabs.length - 1) % tabs.length; if (event.key === 'Home') n = 0; if (event.key === 'End') n = tabs.length - 1; if (n !== undefined) { event.preventDefault(); select(n); tabs[n].focus(); } }); });
        compare.querySelectorAll('[data-kc-thumb]').forEach(thumb => thumb.addEventListener('click', () => select(Number(thumb.dataset.kcThumb))));
        compare.querySelectorAll('[data-kc-mode]').forEach(button => button.addEventListener('click', () => { const drag = button.dataset.kcMode === 'drag'; compare.classList.toggle('is-drag', drag); compare.querySelectorAll('[data-kc-mode]').forEach(b => b.setAttribute('aria-pressed', String(b === button))); compare.querySelectorAll('.kc-range').forEach(label => label.hidden = !drag); }));
        compare.querySelectorAll('[data-kc-range]').forEach(range => range.addEventListener('input', () => range.closest('[data-kc-panel]').querySelector('[data-kc-stage]').style.setProperty('--kc-reveal', range.value + '%')));
      }
      const track = section.querySelector('[data-kc-track]');
      if (track) { const move = direction => { const max = track.scrollWidth - track.clientWidth; let next = track.scrollLeft + direction * track.clientWidth; if (next > max + 5) next = 0; if (next < -5) next = max; track.scrollTo({left: next, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }; section.querySelector('[data-kc-prev]').addEventListener('click', () => move(-1)); section.querySelector('[data-kc-next]').addEventListener('click', () => move(1)); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kira-compare-cases"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kira-compare-cases')) {
    customElements.define('kira-compare-cases', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.styleTabs = [...this.querySelectorAll('[data-kcc-style]')];
        this.addEventListener('click', event => {
          const styleTab = event.target.closest('[data-kcc-style]');
          if (styleTab) this.selectStyle(Number(styleTab.dataset.kccStyle));
          const caseTab = event.target.closest('[data-kcc-case]');
          if (caseTab) this.selectCase(caseTab.closest('[data-kcc-group]'), Number(caseTab.dataset.kccCase));
        });
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[role=tab]');
          if (!tab) return;
          const tabs = [...tab.closest('[role=tablist]').querySelectorAll('[role=tab]')];
          let index = tabs.indexOf(tab), next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            tabs[next].click();
            tabs[next].focus();
          }
        });
        this.addEventListener('shopify:block:select', event => {
          const group = event.target.closest('[data-kcc-group]');
          if (group) this.selectStyle(Number(group.dataset.kccGroup));
        });
      }
      selectStyle(index) {
        this.styleTabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        this.querySelectorAll('[data-kcc-group]').forEach((group, i) => { group.hidden = i !== index; });
      }
      selectCase(group, index) {
        group.querySelectorAll('[data-kcc-case]').forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        group.querySelectorAll('[data-kcc-example]').forEach((panel, i) => { panel.hidden = i !== index; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kira-studio-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kira-studio-gallery')) {
    customElements.define('kira-studio-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', event => {
          const filter = event.target.closest('[data-kg-filter]');
          if (filter) {
            this.querySelectorAll('[data-kg-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
            this.querySelectorAll('[data-kg-category]').forEach(card => { card.hidden = filter.dataset.kgFilter !== 'all' && card.dataset.kgCategory !== filter.dataset.kgFilter; });
          }
          const photo = event.target.closest('[data-kg-photo]');
          if (photo) {
            this.photos = [...this.querySelectorAll('[data-kg-category]:not([hidden]) [data-kg-photo]')];
            this.index = this.photos.indexOf(photo);
            this.showPhoto();
            this.dialog.showModal();
          }
          if (event.target.closest('[data-kg-prev]')) this.movePhoto(-1);
          if (event.target.closest('[data-kg-next]')) this.movePhoto(1);
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.movePhoto(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
      }
      movePhoto(direction) {
        this.index = (this.index + direction + this.photos.length) % this.photos.length;
        this.showPhoto();
      }
      showPhoto() {
        const photo = this.photos[this.index];
        const large = this.querySelector('[data-kg-large]');
        large.src = photo.dataset.image;
        large.alt = photo.querySelector('img').alt;
        this.querySelector('[data-kg-caption]').textContent = photo.dataset.caption + ' · ' + (this.index + 1) + ' / ' + this.photos.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kira-wig-craft"] && !Shopify.designMode) return;
  try {
    
  function initKiraCraft(scope) {
    scope.querySelectorAll('[data-kw-craft-carousel]').forEach(function(root) {
      if (root.dataset.craftReady) return;
      root.dataset.craftReady = 'true';
      const track = root.querySelector('.kw-craft-track');
      const slides = Array.from(track.children);
      if (!slides.length) return;
      const buttons = root.querySelectorAll('[data-kw-craft-step]');
      const page = root.querySelector('.kw-craft-page');
      const nearest = function() {
        return slides.reduce(function(best,slide,index) {
          return Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? index : best;
        },0);
      };
      const update = function() {
        const index = nearest();
        page.textContent = (index + 1) + ' / ' + slides.length;
        buttons.forEach(function(button) { button.disabled = Number(button.dataset.kwCraftStep) < 0 ? index === 0 : index === slides.length - 1; });
      };
      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          const index = Math.max(0,Math.min(slides.length - 1,nearest() + Number(button.dataset.kwCraftStep)));
          track.scrollTo({left:slides[index].offsetLeft - slides[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
      });
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initKiraCraft(document);
  document.addEventListener('DOMContentLoaded', function() { initKiraCraft(document); });
  document.addEventListener('shopify:section:load', function(event) { initKiraCraft(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kira-wig-styled"] && !Shopify.designMode) return;
  try {
    
  function initKiraBenefits(scope) {
    scope.querySelectorAll('.kw-wig-points').forEach(function(points) {
      if (points.dataset.benefitsReady) return;
      points.dataset.benefitsReady = 'true';
      const mobile = window.matchMedia('(max-width:767px)');
      const adapt = function() {
        points.querySelectorAll('.kw-benefit').forEach(function(item) {
          item.open = !mobile.matches;
          item.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
        });
      };
      adapt();
      mobile.addEventListener('change', adapt);
    });
  }
  initKiraBenefits(document);
  document.addEventListener('DOMContentLoaded', function() { initKiraBenefits(document); });
  document.addEventListener('shopify:section:load', function(event) { initKiraBenefits(event.target); });

  } catch(e) { console.error(e); }
})();
})();
